import { __assign, __rest } from "tslib";
import React, { forwardRef, useRef } from 'react';
import { useForkRef, useTheme, useThemeProps, } from '../../../foundation';
import { duration, getTransitionProps, reflow, setTransitionStyle, Transition, } from '../Transition';
import { useNormalizedTransitionProps } from '../utils';
import { transformToFromElm } from './utils';
var styles = {
    entering: {
        transform: '',
    },
    entered: {},
    exiting: {
        transform: '',
    },
    exited: {},
};
var RcZoomFrom = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcZoomFrom' });
    var fromRef = props.from, children = props.children, inProp = props.in, style = props.style, timeout = props.timeout, onExit = props.onExit, onEnter = props.onEnter, onExited = props.onExited, onExiting = props.onExiting, onEntering = props.onEntering, other = __rest(props, ["from", "children", "in", "style", "timeout", "onExit", "onEnter", "onExited", "onExiting", "onEntering"]);
    var theme = useTheme();
    var nodeRef = useRef(null);
    var handlers = useNormalizedTransitionProps(__assign(__assign({}, props), { onEnter: function (node, isAppearing) {
            transformToFromElm(fromRef, nodeRef);
            reflow(node); // So the animation always start from the start.
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(node, isAppearing);
        }, onEntering: function (node, isAppearing) {
            var transitionProps = getTransitionProps(props, {
                mode: 'enter',
            });
            var transitionStyle = theme.transitions.create(['all'], transitionProps);
            setTransitionStyle(node, transitionStyle);
            onEntering === null || onEntering === void 0 ? void 0 : onEntering(node, isAppearing);
        }, onExit: function (node) {
            var transitionProps = getTransitionProps(props, {
                mode: 'exit',
            });
            var transitionStyle = theme.transitions.create(['all'], transitionProps);
            setTransitionStyle(node, transitionStyle);
            onExit === null || onExit === void 0 ? void 0 : onExit(node);
        }, onExiting: function (node) {
            transformToFromElm(fromRef, nodeRef);
            reflow(node); // So the animation always start from the start.
            onExiting === null || onExiting === void 0 ? void 0 : onExiting(node);
        }, onExited: function (node) {
            setTransitionStyle(node, '');
            onExited === null || onExited === void 0 ? void 0 : onExited(node);
        } }), nodeRef);
    var foreignRef = useForkRef(children.ref, ref);
    var handleRef = useForkRef(nodeRef, foreignRef);
    return (React.createElement(Transition, __assign({ appear: true, timeout: timeout, nodeRef: nodeRef, in: inProp }, handlers, other), function (state, childProps) {
        return React.cloneElement(children, __assign({ style: __assign(__assign(__assign({ visibility: state === 'exited' && !inProp ? 'hidden' : undefined }, style), children.props.style), styles[state]), ref: handleRef }, childProps));
    }));
});
RcZoomFrom.defaultProps = {
    timeout: {
        enter: duration.enteringScreen,
        exit: duration.enteringScreen,
    },
};
RcZoomFrom.displayName = 'ZoomInFadeOut';
export { RcZoomFrom };
